<script lang="ts">
  import type { Snippet } from "svelte";
  import type { ClassValue } from "svelte/elements";

  interface Props {
    children?: Snippet;
    class?: ClassValue;
  }

  let { children, class: className }: Props = $props();
</script>

<tbody class={["bg-mono-000", className]}>
  {@render children?.()}
</tbody>
